import { Notifications as MantineNotifications } from "@mantine/notifications";
import React from "react";
import { useStyles } from "./Notifications.styles";

export const Notifications: React.FC = () => {
  const { classes } = useStyles();

  return <MantineNotifications position="top-right" className={classes.notifications} />;
};
